import { Box, Link, useTheme } from '@mui/material'
import React, { useCallback } from 'react'
import { Trans } from 'react-i18next'
import { userSignOut } from '../../../../utils/Firebase/methods'
import { useNavigate } from 'react-router-dom'
import { LogOut } from 'react-feather'
import { linkStyle, logoutIconStyle } from './LogoutButton.styles'
import { LOGIN_PATH } from '../../../../routes/LoginRoutes'

export default function LogoutButton() {
	const nav = useNavigate()
	const { palette } = useTheme()

	const handleLogout = useCallback(async () => {
		try {
			await userSignOut()
			nav(LOGIN_PATH)
			console.log('User logged out')
		} catch (error) {
			console.error('Logout failed', error)
		}
	}, [nav])

	return (
		<Box p="0 48px">
			<Link component="button" onClick={handleLogout} display="flex" sx={linkStyle(palette)}>
				<LogOut style={logoutIconStyle} />
				<Trans i18nKey="account.logout_button" />
			</Link>
		</Box>
	)
}
